import { render, staticRenderFns } from "./DecodeRef.vue?vue&type=template&id=880ca722&"
import script from "./DecodeRef.vue?vue&type=script&lang=js&"
export * from "./DecodeRef.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports